import React from 'react'
import constants from 'common/helpers/constants'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const UnskipSuccessModal = composeDialogModal({
  name: constants.modals.UnskipSuccess,
  title: messages.title,
  contentMessage: messages.text,
})

export default UnskipSuccessModal
